<div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
        <p class="govuk-body">Please enter the <strong>Booking ID</strong> from the <strong>ceremony rota</strong>
            below and click <strong>Search</strong></p>
    </div>
</div>

<div class="govuk-grid-row">
    <div class="govuk-grid-column-one-half  ">
        <div class="govuk-grid-row">
            <div class="govuk-grid-column-one-third">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--l" for="search-field">
                        Search
                    </label>
                </h1>
            </div>
            <div class="govuk-grid-column-one-half">
                <input class="govuk-input" id="event-name" name="search-field" type="text" [(ngModel)]="searchText">
            </div>
        </div>
    </div>
    <div class="govuk-grid-column-one-quarter">

        <span *ngIf="!this.noShowAllConfirmToggle">
            <button class="govuk-button govuk-button--secondary" data-module="govuk-button"
                (click)="this.noShowAllConfirmToggle = true" *ngIf="tableData?.buttons['noShowAll']">
                Mark all as No Show
            </button>
        </span>
        <span *ngIf="this.noShowAllConfirmToggle">
            <div class="areYouSure"><label class="govuk-label ">Are you sure?</label></div>
            <div class="govuk-button-group">
                <button class="govuk-button" data-module="govuk-button" (click)="noShowAll()"
                    *ngIf="tableData?.buttons['noShowAll']">
                    Yes
                </button>
                <button class="govuk-button govuk-button--secondary" data-module="govuk-button"
                    (click)="this.noShowAllConfirmToggle = false" *ngIf="tableData?.buttons['noShowAll']">
                    No
                </button>
            </div>
        </span>
        <span *ngIf="!tableData?.buttons['noShowAll']">
            <br>
        </span>
    </div>
    <div class="govuk-grid-column-one-quarter">
        <span>
            <button class="govuk-button govuk-button--primary" data-module="govuk-button" (click)="search()">
                Search
            </button>
            <!-- <button (click)="this.params = ''">debug</button> -->

        </span>
    </div>
</div>

<table *ngIf="loadedTable && bookings.length > 0" class="govuk-table" style="table-layout: fixed; width:100%">

    <thead class="govuk-table__head">
        <tr class="govuk-table__row">
            <ng-container *ngFor="let tab of tableData.tabs;">
                <th class="govuk-table__header" [ngStyle]="tab.width && {'width': tab.width+'%'}">{{tab.heading}}</th>
            </ng-container>
        </tr>
    </thead>
    <virtual-scroller #virtualScroller [items]="bookings" [enableUnequalChildrenSizes]="true">
        <tbody #container class="govuk-table__body" style="display:table;width:100%;">
            <ng-container *ngFor="let bookingDetails of virtualScroller.viewPortItems; index as i">
                <!-- NEW SINGLE ROW TABLE -->
                <tr class="govuk-table__row scroll-item">
                    <td style="width: 100%; display: table;">
                        <table style="width: 100%;">
                            <tr class="govuk-table__row">
                                <ng-container *ngFor="let tab of tableData.tabs;">
                                    <td class="govuk-table__cell" [ngStyle]="tab.width && {'width': tab.width+'%'}"
                                        [innerHTML]="getDataForTable(bookingDetails,tab)"></td>
                                </ng-container>
                            </tr>
                            <tr class="govuk-table__row">
                                <td colspan="99" class="govuk-table__cell">
                                    <div class="govuk-button-group">
                                        <button *ngIf="tableData?.buttons['confirmed']"
                                            class="govuk-button govuk-button--warning" data-module="govuk-button"
                                            (click)="updateStatus(bookingDetails,'', $event)">
                                            {{tableData?.buttons['confirmed']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['arrived']" class="govuk-button"
                                            data-module="govuk-button"
                                            (click)="updateStatus(bookingDetails,'arrived', $event)">
                                            {{tableData?.buttons['arrived']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['noShow']"
                                            class="govuk-button govuk-button--warning" data-module="govuk-button"
                                            (click)="updateStatus(bookingDetails,'noShow', $event)">
                                            {{tableData?.buttons['noShow']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['rejected']"
                                            class="govuk-button govuk-button--warning" data-module="govuk-button"
                                            (click)="updateStatus(bookingDetails,'rejected', $event)">
                                            {{tableData?.buttons['rejected']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['arrived_and_paid']"
                                            class="govuk-button govuk-button--warning" data-module="govuk-button"
                                            style="background-color:dodgerblue;"
                                            (click)="updateStatus(bookingDetails,'arrived_and_paid', $event)">
                                            {{tableData?.buttons['arrived_and_paid']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['notes']"
                                            class="govuk-button  govuk-button--secondary" data-module="govuk-button"
                                            (click)="changeNoteShowStatus(bookingDetails, $event)">
                                            {{tableData?.buttons['notes']}}
                                        </button>
                                        <button *ngIf="tableData?.buttons['readOnlyQuestions']"
                                            class="govuk-button  govuk-button--secondary" data-module="govuk-button"
                                            (click)="changeQuestionROShowStatus(bookingDetails, $event)">
                                            {{tableData?.buttons['readOnlyQuestions'].name}}
                                        </button>
                                        <!-- config driven button order -->
                                        <ng-container *ngFor="let key of tableData?.button_order">
                                            <button *ngIf="tableData?.buttons[key]"
                                                class="govuk-button govuk-button--secondary" data-module="govuk-button"
                                                (click)="handleButtonClick(key, bookingDetails, $event)">

                                                <ng-container *ngIf="tableData?.buttons[key]?.name">
                                                    {{ tableData?.buttons[key].name }}
                                                </ng-container>
                                                <ng-container *ngIf="!tableData?.buttons[key]?.name">
                                                    {{ tableData?.buttons[key] }}
                                                </ng-container>

                                            </button>
                                        </ng-container>
                                        <!-- config driven button order -->
                                    </div>
                                </td>
                            </tr>
                            <ng-container *ngIf="bookingDetails.showNote">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <table style="width: 100%;">
                                            <tbody>
                                                <tr class="govuk-table__row">
                                                    <td class="govuk-table__cell" style="border-bottom:0px !important"
                                                        colspan="9999" style="display:table;width:100%;">
                                                        <span *ngIf="showNotesDropdown()">
                                                            <label class="govuk-label govuk-label--s">* Please select an
                                                                option:</label>
                                                            <select [(ngModel)]="bookingDetails.option"
                                                                class="govuk-select">
                                                                <option [ngValue]="''">

                                                                </option>
                                                                <option
                                                                    *ngFor="let op of this.config.set.notesDropDown.options"
                                                                    [ngValue]="op">
                                                                    {{op}}
                                                                </option>
                                                            </select>
                                                            <br>
                                                            <br>
                                                        </span>
                                                        <textarea class="govuk-textarea" placeholder="Add notes"
                                                            style="width: 100%;" [(ngModel)]="bookingDetails.note"
                                                            required *ngIf="notesTextField()"></textarea>
                                                        <button *ngIf="tableData?.buttons['notes']"
                                                            class="govuk-button  govuk-button--secondary"
                                                            data-module="govuk-button"
                                                            [disabled]="bookingDetails.option === '' && showNotesDropdown()"
                                                            (click)="addNote(bookingDetails)">
                                                            Save
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="bookingDetails.uploadShow">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <table style="width: 100%;">
                                            <tbody>
                                                <!-- <tr class="govuk-table__row">
                                                    <td class="govuk-table__cell" style="border-bottom:0px !important"
                                                        colspan="9999" style="display:table;width:100%;">
                                                        <b></b>
                                                    </td>
                                                </tr> -->
                                                <tr class="govuk-table__row">
                                                    <td class="govuk-table__cell" style="border-bottom:0px !important"
                                                        colspan="9999" style="display:table;width:100%;">
                                                        <div
                                                            [ngClass]="{'govuk-form-group': true, 'govuk-form-group--error': fileError}">
                                                            <p *ngIf="fileError" id="file-upload-1-error"
                                                                class="govuk-error-message">
                                                                <span class="govuk-visually-hidden">Error:</span>
                                                                Document exceed 10MB.
                                                            </p>
                                                            <input class="govuk-file-upload" id="file-upload-1"
                                                                name="fileUpload1" type="file"
                                                                (change)="uploadTest(bookingDetails,$event)">
                                                            <!-- [accept]="field.filetypes.join(',')" -->
                                                            <button class="govuk-button  govuk-button--secondary"
                                                                data-module="govuk-button"
                                                                [disabled]="fileData === undefined"
                                                                (click)="saveFile(bookingDetails)">
                                                                Save
                                                            </button>
                                                            <label class="govuk-label">
                                                                Document must not exceed 10MB.
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="bookingDetails.showAttachments">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">

                                        <table style="display:table;width:100%;">
                                            <thead class="govuk-table__row">
                                                <th class="govuk-table__header govuk-grid-column-one-half">Name</th>
                                                <th class="govuk-table__header govuk-grid-column-one-quarter">Size</th>
                                                <th class="govuk-table__header govuk-grid-column-one-quarter">Actions
                                                </th>
                                            </thead>
                                            <tr class=" govuk-table__row"
                                                *ngFor="let file of this.bookingFiles.attachments">
                                                <td class="govuk-table__cell noBottom govuk-grid-column-one-half">
                                                    {{file.name}}
                                                </td>
                                                <td class="govuk-table__cell noBottom govuk-grid-column-one-quarter">
                                                    {{fileSizeCalc(file.file_size) / 1000}} MB
                                                </td>
                                                <td class="govuk-table__cell noBottom govuk-grid-column-one-quarter">
                                                    <span>
                                                        <a class="govuk-button  govuk-button--secondary"
                                                            href="{{file.url}}" target="_blank">View</a>

                                                        <button class="govuk-button  govuk-button--secondary"
                                                            *ngIf="!file.delete && !this.tableData.buttons['attachments'].hideDelete"
                                                            data-module="govuk-button" (click)="file.delete = true">
                                                            Delete
                                                        </button>
                                                    </span>
                                                    <span *ngIf="file.delete">
                                                        <button class="govuk-button  govuk-button--secondary"
                                                            data-module="govuk-button"
                                                            (click)="deleteFile(bookingDetails,file)">
                                                            Confirm
                                                        </button>
                                                        <button class="govuk-button  govuk-button--secondary"
                                                            data-module="govuk-button" (click)="file.delete = false">
                                                            Cancel
                                                        </button>
                                                    </span>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="bookingDetails.choicesShow">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <table style="display:table;width:100%;" id="bookingQuestions">

                                            <thead class="govuk-table__row">
                                                <th class="govuk-table__header govuk-grid-column-one-half">Question</th>
                                                <th class="govuk-table__header govuk-grid-column-one-quarter">Answer
                                                </th>
                                            </thead>

                                            <ng-container *ngFor="let question of schema">
                                                <tr *ngIf="!question.onBlacklist && question.visible">

                                                    <ng-container *ngIf="question.type === 'heading'">
                                                        <td colspan="9999" style="display:table;width:100%;"
                                                            class="govuk-table__cell noBottom govuk-grid-column"
                                                            [innerHTML]="question.title">
                                                        </td>
                                                    </ng-container>
                                                    <ng-container *ngIf="question.type !== 'heading'">
                                                        <td class="govuk-table__cell noBottom govuk-grid-column-one-half"
                                                            [innerHTML]="question.title">
                                                        </td>

                                                        <td
                                                            class="govuk-table__cell noBottom govuk-grid-column-one-half"   [innerHTML]="findAnswer(question.field)">

                                                        </td>
                                                        <br>
                                                    </ng-container>
                                                </tr>
                                            </ng-container>
                                        </table>
                                    </td>
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <button class="govuk-button  govuk-button--secondary" data-module="govuk-button"
                                            (click)="print()">
                                            Print
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>

                            <ng-container *ngIf="bookingDetails.showQuestionsRO">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                    <table style="display:table;width:100%;">
                                        <tbody>
                                        <ng-container *ngFor="let row of preparedTableData">
                                            <tr class="govuk-table__row" style="overflow: hidden;">
                                            <td class="govuk-table__cell noBottom"
                                                style="font-weight: bold; width: 50%; padding-right: 0; float: left;">
                                                {{ row.name }}
                                            </td>
                                            <td class="govuk-table__cell noBottom"
                                                style="width: 50%; float: left;">
                                                {{ row.value }}
                                            </td>
                                            </tr>
                                        </ng-container>
                                        </tbody>
                                    </table>
                                    </td>
                                </tr>
                                <br>
                            </ng-container>


                            <ng-container *ngIf="bookingDetails.checkListShow">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <table style="display:table;width:100%;">
                                            <tbody>
                                                <div *ngIf="!bookingDetails.settings.task_manager">
                                                    Checklist not set by staff
                                                </div>
                                                <ng-container
                                                    *ngFor="let content of bookingDetails.settings.task_manager">
                                                    <tr class="govuk-table__row" style="overflow: hidden;">
                                                        <td class="govuk-table__cell noBottom"
                                                            style="font-weight: bold; width: 50%; padding-right: 0; float: left;">
                                                            {{content.name}}
                                                        </td>
                                                        <td class="govuk-table__cell noBottom"
                                                            style="width: 50%; float: left;">
                                                            {{content.note || 'N/A'}}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <br>
                            </ng-container>

                            <ng-container *ngIf="bookingDetails.amendQuestionsShow">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <div [formGroup]="bookingDetails.bookingQuestionsForm">
                                            <ng-container
                                                *ngFor="let question of bookingDetails.service.bookingQuestions;">
                                                <div *ngIf="question.visible && this.inModifiableQuestionsList(question.id)"
                                                    [ngClass]="{ 'govuk-form-group--error': (bookingDetails.bookingQuestionsForm.controls[question.id]?.errors?.required || bookingDetails.bookingQuestionsForm.controls[question.id]?.errors?.invalid || bookingDetails.bookingQuestionsForm.controls[question.day_id]?.errors?.required || bookingDetails.bookingQuestionsForm.controls[question.day_id]?.errors?.invalid || bookingDetails.bookingQuestionsForm.controls[question.day_id]?.errors?.min || bookingDetails.bookingQuestionsForm.controls[question.id]?.errors?.min || bookingDetails.bookingQuestionsForm.controls[question.day_id]?.errors?.max || bookingDetails.bookingQuestionsForm.controls[question.day_id]?.errors?.pattern), 'govuk-form-group': true }">

                                                    <!-- LABEL-->
                                                    <label for="{{bookingDetails.booking.id}}{{question.id}}"
                                                        class="govuk-label govuk-label--s"
                                                        *ngIf="question.visible && question.detail_type != 'check' && question.detail_type != 'check-price'">{{question.name}}<span
                                                            *ngIf="question.required" class="mandatory">*</span></label>

                                                    <p class="govuk-error-message"
                                                        *ngIf="question.visible &&  bookingDetails.bookingQuestionsForm.controls[question.id]?.errors?.required">
                                                        <span class="govuk-visually-hidden">Error:</span>
                                                        {{question.name}} is
                                                        mandatory
                                                    </p>
                                                    <p class="govuk-error-message"
                                                        *ngIf="question.visible &&  (bookingDetails.bookingQuestionsForm.controls[question.id+'_day']?.errors?.required || bookingDetails.bookingQuestionsForm.controls[question.id+'_day']?.errors?.invalid)">
                                                        <span class="govuk-visually-hidden">Error:</span>
                                                        {{question.name}} is
                                                        mandatory
                                                    </p>

                                                    <!--TEXT FIELD-->
                                                    <input
                                                        *ngIf="question.visible && question.detail_type === 'text_field'"
                                                        [ngClass]="{ 'govuk-input--error': bookingDetails.bookingQuestionsForm.controls[question.id].errors?.required, 'govuk-input': true }"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}" type="text"
                                                        formControlName="{{question.id}}"
                                                        attr.aria-label="{{question.name}}">
                                                    <input *ngIf="question.visible && question.detail_type === 'date'"
                                                        [ngClass]="{ 'govuk-input--error': bookingDetails.bookingQuestionsForm.controls[question.id].errors?.required, 'govuk-input': true }"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}" type="date"
                                                        formControlName="{{question.id}}"
                                                        attr.aria-label="{{question.name}}">

                                                    <!--NUMBER FIELD-->
                                                    <input *ngIf="question.visible && question.detail_type === 'number'"
                                                        [ngClass]="{ 'govuk-input--error':  bookingDetails.bookingQuestionsForm.controls[question.id].errors?.required, 'govuk-input': true }"
                                                        id="{{question.id}}" type="number" pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}" type="number"
                                                        pattern="[0-9]*" inputmode="numeric"
                                                        formControlName="{{question.id}}"
                                                        attr.aria-label="{{question.name}}"
                                                        (keypress)="keyPressNumberField($event)">

                                                    <!--TEXT AREA-->
                                                    <textarea
                                                        *ngIf="question.visible && question.detail_type === 'text_area'"
                                                        [ngClass]="{ 'govuk-textarea--error': bookingDetails.bookingQuestionsForm.controls[question.id].errors?.required, 'govuk-textarea': true }"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}"
                                                        formControlName="{{question.id}}" rows="5"
                                                        aria-describedby="question.name"></textarea>

                                                    <!-- RADIO-->
                                                    <fieldset
                                                        *ngIf="question.visible && question.visible && question.detail_type === 'radio'"
                                                        class="govuk-fieldset">
                                                        <div class="govuk-radios" data-module="govuk-radios"
                                                            *ngFor="let radio of question.options">
                                                            <div class="govuk-radios__item"
                                                                style="margin-bottom: 10px;">
                                                                <input class="govuk-radios__input" type="radio"
                                                                    (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                                    value="{{radio.name}}"
                                                                    formControlName="{{question.id}}"
                                                                    id="{{bookingDetails.booking.id}}{{radio.name}}">
                                                                <label for="{{bookingDetails.booking.id}}{{radio.name}}"
                                                                    class="govuk-label govuk-radios__label">
                                                                    {{radio.name}}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <!--RADIO PRICE-->
                                                    <fieldset
                                                        *ngIf="question.visible && question.detail_type === 'radio-price'"
                                                        class="govuk-fieldset">
                                                        <div class="govuk-radios" data-module="govuk-radios"
                                                            *ngFor="let radio of question.options">
                                                            <div class="govuk-radios__item"
                                                                style="margin-bottom: 10px;">
                                                                <input class="govuk-radios__input"
                                                                    id="{{bookingDetails.booking.id}}{{radio.name}}"
                                                                    (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                                    type="radio" value="{{radio.name}}"
                                                                    formControlName="{{question.id}}">
                                                                <label for="{{bookingDetails.booking.id}}{{radio.name}}"
                                                                    class="govuk-label govuk-radios__label">
                                                                    {{radio.name}} ({{radio.price / 100 |
                                                                    currency:'GBP':"symbol"}})
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <!--SELECT-->
                                                    <select style="width:100%"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}"
                                                        *ngIf="question.visible && question.detail_type === 'select'"
                                                        class="govuk-select" formControlName="{{question.id}}"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)">
                                                        <option [value]=""></option>
                                                        <ng-container
                                                            *ngFor="let select of question.options ; index as k; ">
                                                            <option value="{{select.name}}">
                                                                {{select.name}}
                                                            </option>
                                                        </ng-container>
                                                    </select>

                                                    <!--SELECT PRICE-->
                                                    <select style="width:100%"
                                                        id="{{bookingDetails.booking.id}}{{question.id}}"
                                                        *ngIf="question.visible && question.detail_type === 'select-price'"
                                                        class="govuk-select" formControlName="{{question.id}}"
                                                        (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)">
                                                        <option [value]=""></option>
                                                        <option value="{{select.name}}"
                                                            *ngFor="let select of question.options">
                                                            {{select.name}} ({{select.price / 100 |
                                                            currency:'GBP':"symbol"}})
                                                        </option>
                                                    </select>
                                                    <!--CHECKBOX-->
                                                    <div *ngIf="question.visible && question.detail_type === 'check'"
                                                        class="govuk-checkboxes" data-module="govuk-checkboxes">
                                                        <div class="govuk-checkboxes__item">

                                                            <input id="{{bookingDetails.booking.id}}{{question.id}}"
                                                                (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)"
                                                                class="govuk-checkboxes__input" type="checkbox"
                                                                formControlName="{{question.id}}">
                                                            <label for="{{bookingDetails.booking.id}}{{question.id}}"
                                                                class="govuk-label govuk-checkboxes__label">
                                                                {{question.name}}
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <!--CHECKBOX PRICE-->
                                                    <div *ngIf="question.visible && question.detail_type === 'check-price'"
                                                        class="govuk-checkboxes" data-module="govuk-checkboxes">
                                                        <div class="govuk-checkboxes__item">
                                                            <input id="{{bookingDetails.booking.id}}{{question.id}}"
                                                                class="govuk-checkboxes__input" type="checkbox"
                                                                formControlName="{{question.id}}"
                                                                (change)="onQuestionChange(bookingDetails.bookingQuestionsForm,bookingDetails)">
                                                            <label for="{{bookingDetails.booking.id}}{{question.id}}"
                                                                class="govuk-label govuk-checkboxes__label">
                                                                {{question.name}} ({{question.price / 100 |
                                                                currency:'GBP':"symbol"}})
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- <div *ngIf="question.visible && question.help_text" class="govuk-hint"
                                                    style="margin-top: -20px">
                                                    {{question.help_text}}
                                                </div> -->
                                                <!-- br instead of changing css -->

                                            </ng-container>

                                        </div>
                                        <button class="govuk-button  govuk-button--secondary" data-module="govuk-button"
                                            (click)="saveQuestionUpdate(bookingDetails)"
                                            *ngIf="bookingDetails.bookingQuestionsForm.status === 'VALID'">
                                            Save
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>

                            <ng-container *ngIf="this.config.wasteLimits">
                                <ng-container *ngIf="bookingDetails.settings?.thisBookingDayLimit?.limitBreached">
                                    <tr class="govuk-table__row">
                                        <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                            <div class="govuk-warning-text limit-question-headers">
                                                <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                                                <strong class="govuk-warning-text__text">
                                                    <span class="govuk-warning-text__assistive">Warning</span>
                                                    Number of DIY visits limit exceeded by
                                                    {{bookingDetails.settings?.thisBookingDayLimit?.amount
                                                    - bookingDetails.settings?.thisBookingDayLimit?.limit}}
                                                </strong>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-container
                                    *ngIf="bookingDetails.settings?.thisBookingWeightLimit?.limitBreached && checkIfHasWaste(bookingDetails.booking) === 'Yes'">
                                    <tr class="govuk-table__row">
                                        <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                            <div class="govuk-warning-text limit-question-headers">
                                                <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                                                <strong class="govuk-warning-text__text">
                                                    <span class="govuk-warning-text__assistive">Warning</span>
                                                    DIY waste limit exceeded. Payment for
                                                    {{bookingDetails.settings?.thisBookingWeightLimit?.amount
                                                    - bookingDetails.settings?.thisBookingWeightLimit?.limit -
                                                    bookingDetails.settings?.thisBookingWeightLimit?.paid_qty}}
                                                    {{wasteUnits}} required for this visit.
                                                </strong>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                            </ng-container>
                            <ng-container *ngIf="regObserved(bookingDetails,tableData.tabs)">
                                <tr class="govuk-table__row">
                                    <td colspan="9999" class="govuk-table__cell" style="display:table;width:100%;">
                                        <div class="govuk-warning-text limit-question-headers">
                                            <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                                            <strong class="govuk-warning-text__text">
                                                <span class="govuk-warning-text__assistive">Warning</span>
                                                {{regObserved(bookingDetails,tableData.tabs)}}
                                            </strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr class="govuk-table__row">
                                <td colspan="9999" class="govuk-table__cell line-break"
                                    style="margin: 0px; padding: 0px; width: 100%;">
                                    <hr>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <!-- END NEW SINGLE ROW TABLE -->


            </ng-container>
        </tbody>
    </virtual-scroller>

</table>